import axios from "axios";
import baseUrl from "../config/baseURL";
import { getAuthToken } from "../services/auth";


export const fetchInitialOveralAnalytics = async (organization_id: any) => {
  console.log('Fetching leads from api');
  let token = await getAuthToken();
  if (!token?.success || !token.data) {
    return { success: false, data: "error: Token does not exist" };
  }
  const header_token = "Bearer " + token.data;
  const headers = {
    Authorization: header_token,
  };
  let url = `${baseUrl}/core/organizations/${organization_id}/analytics/overview`;

  try {
      const response:any = await axios.get(url, { headers });

      if (response.status >= 200 && response.status <= 400) {
        return { success: true, data: response.data };
      } else {
        console.error("Data fetch failed at response:", response);
        return { success: false, data: response?.data };
      }
  } catch (error) {
    console.error("Unexpected error occurred while fetching leads:", error);
    return { success: false, data: error };
  }
};
